import { defineMessages } from "react-intl";

const baseId = "t.pages.Report.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "REPORTS",
  },
  CAMPAIGNS_NAMES: {
    id: baseId + "CAMPAIGNS_NAMES",
    defaultMessage: "Recertification campaign",
  },
});
